import { render, staticRenderFns } from "./SegmentedPickerTabs.vue?vue&type=template&id=20d4df3b&scoped=true"
import script from "./SegmentedPickerTabs.vue?vue&type=script&lang=js"
export * from "./SegmentedPickerTabs.vue?vue&type=script&lang=js"
import style0 from "./SegmentedPickerTabs.vue?vue&type=style&index=0&id=20d4df3b&prod&scoped=true&lang=css"
import style1 from "./SegmentedPickerTabs.vue?vue&type=style&index=1&id=20d4df3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d4df3b",
  null
  
)

export default component.exports